// ** Third Party Components
import styled from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledLeftSection = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	max-width: 325px;
	min-width: 325px;
	gap: var(--size-grid);

	@media (max-width: ${breakpoints.desktop - 1}px) {
		max-width: none;
		width: 100%;
		flex-grow: 0;
	}
`;

// #####################################################
